import { MutationTree } from 'vuex';
import { PushApplicationState } from './types';

export const mutations: MutationTree<PushApplicationState> = {
  setPushApplications: (state, data) => {
    state.pushApplications = data
  },
  setPushApplication: (state, data) => {
    state.pushApplication = data
  },
  setPushOS: (state, data) => {
    state.pushOS = data;
  },
  setPushOSVersions: (state, data) => {
    state.pushOSVersions = data;
  },
  setPushSDKVersions: (state, data) => {
    state.pushSDKVersions = data;
  },
  setPushMappVersions: (state, data) => {
    state.pushMappVersions = data;
  },
  setPushFilters: (state, data) => {
    state.pushFilters = data;
  },
  setPushGroupApplications: (state, data) => {
    state.pushGroupApplications = data;
  },
}
